// ANX-102 — последний использованный слаг организации. Chrome не
// автозаполняет это поле (нестандартный логин из трёх полей), поэтому
// запоминаем сами и префиллим на форме входа / восстановления пароля.

export const LAST_TENANT_KEY = 'anexica.lastTenant.v1';

export function readLastTenant(): string {
  try {
    return localStorage.getItem(LAST_TENANT_KEY) ?? '';
  } catch {
    return '';
  }
}

export function saveLastTenant(slug: string): void {
  try {
    localStorage.setItem(LAST_TENANT_KEY, slug);
  } catch {
    /* private mode / storage disabled — префилл просто не сработает */
  }
}
